import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { ChangeStatusProps } from 'shared/services';

export function useChangeStatus() {
    const { productService } = useService();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();
    const mutation = useMutation<string, Error, ChangeStatusProps>(request => productService.changeStatus(request), {
        onSuccess: message => {
            enqueueSnackbar(message, { variant: 'success' });
            queryClient.invalidateQueries('products');
        },
    });

    return mutation;
}
